// removed by extract-text-webpack-plugin
module.exports = {"label":"_1eMZFVlASiK69PbBoHAi7J","labelText":"_3SEMIzEku3DRUMy6lpipBG","input":"_2bE0-lkPgKtQ5vXwHofKzg"};


//////////////////
// WEBPACK FOOTER
// ./src/react/ui/TextInput.styl
// module id = 729
// module chunks = 0